/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';

import s from './styles.module.less';

const CellDescription = ({ className, label, children }) => {
  const mergedClassname = clsx(className, s.note);

  return (
    <>
      {label && (
        <>
          <span className={mergedClassname}>{label}</span>
          <br />
        </>
      )}
      <span className={mergedClassname}>{children}</span>
    </>
  );
};

export default CellDescription;
